<script setup lang="ts">
import type { SectionContactFormRecord } from '~/types/datocms'

const props = defineProps<{
  data: SectionContactFormRecord
  moduleIndex: number
}>()

const appConfig = useAppConfig()
const isFormSubmitted = ref(false)

const { level, isSemantic, invertedStyles } = useSectionRules(
  props.moduleIndex,
  props.data.invertColorTheme,
  !!props.data.title
)
</script>

<template>
  <div class="container grid-default page-pt" :class="invertedStyles">
    <ClientOnly v-if="appConfig.ui.enableFluidThree">
      <FluidBlack />
    </ClientOnly>
    <div class="col-span-full">
      <Heading
        v-if="data.title"
        :size="1"
        :level="level"
        :is-semantic="isSemantic"
        class="mb-8 lg:mb-24"
        ><TextReveal
          ><TextClip class="bg-[135%_50%]">{{ data.title }}</TextClip></TextReveal
        ></Heading
      >
    </div>
    <div class="order-2 col-span-full gap-4 lg:order-1 lg:col-span-4">
      <div class="mt-13 flex flex-col gap-4 text-sm font-medium lg:text-base">
        <p class="lg:text-lg">Prefer contacting us directly?</p>
        <p>
          <a class="fx-underline text-neutral-500" href="mailto:info@atlascreative.com"
            >info@atlascreative.com</a
          >
        </p>
        <p class="lg:text-lg">Follow us</p>
        <div class="text-neutral-500">
          <div>
            <a
              href="https://x.com/AtlasCreativeFN"
              target="_blank"
              rel="noopener"
              class="fx-underline"
              >Twitter / X</a
            >
          </div>
          <div>
            <a
              href="https://www.tiktok.com/@atlascreativefn"
              target="_blank"
              rel="noopener"
              class="fx-underline"
              >TikTok</a
            >
          </div>
          <div>
            <a
              href="https://www.linkedin.com/company/atlascreative/"
              target="_blank"
              rel="noopener"
              class="fx-underline"
              >Linkedin</a
            >
          </div>
          <div>
            <a
              href="https://discord.com/invite/atlas-creative-516619453887414284"
              target="_blank"
              rel="noopener"
              class="fx-underline"
              >Discord</a
            >
          </div>
        </div>
        <p class="lg:text-lg">Address</p>
        <p class="text-neutral-500">4893 Whitlow Ridge Dr<br />Bishop GA 30621<br />USA</p>
      </div>
    </div>
    <div class="order-1 col-span-full lg:order-2 lg:col-span-8">
      <NetlifyContactForm v-if="!isFormSubmitted" @submit="isFormSubmitted = true" />
      <ThankYouMessage v-else :message="data.thankYouMessage" />
    </div>
  </div>
</template>
